/* ==========================================================
   ARTO INSPIRATION GALLERY — Cart & UI Script
   File path: assets/inspiration-gallery.js

   Handles "Add Sample" → Shopify cart integration,
   "Order all samples" bulk add, and toast notifications.
   ========================================================== */

(function() {
  'use strict';

  // ── Cart drawer open-on-load (mirrors product page behaviour) ──────────
  if (window.location.search.includes('open_cart=1')) {
    window.history.replaceState({}, '', window.location.pathname);
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(function() {
        if (window.themeCore && window.themeCore.EventBus) {
          window.themeCore.EventBus.emit('cart:drawer:refresh-and-open');
        }
      }, 500);
    });
  }

  // Find all sample buttons on the page
  const sampleButtons = document.querySelectorAll('.ag-add-sample');
  const orderAllButtons = document.querySelectorAll('#ag-order-all, #ag-order-all-cta');
  const toast = document.getElementById('ag-toast');
  const toastMsg = document.getElementById('ag-toast-msg');

  if (!sampleButtons.length && !orderAllButtons.length) {
    return; // Not on a project page
  }

  // Tag samples added from a project page so orders show which project they came from.
  // Properties starting with "_" are hidden from the customer in the cart.
  const galleryEl = document.querySelector('.arto-gallery[data-project]');
  const projectName = galleryEl ? galleryEl.dataset.project : '';
  const sourceProps = projectName ? { _Project: projectName, _Source: 'Project gallery' } : {};

  let toastTimeout;
  function showToast(message, success) {
    if (!toast || !toastMsg) return;
    clearTimeout(toastTimeout);
    toastMsg.textContent = message;
    toast.classList.add('show');
    toastTimeout = setTimeout(() => toast.classList.remove('show'), 3500);
  }

  /**
   * Add a single sample to the cart via Shopify's cart API,
   * then redirect to trigger the cart drawer open.
   */
  async function addSample(variantId, name, button) {
    if (button) {
      button.classList.add('loading');
      button.dataset.originalText = button.textContent;
      button.textContent = 'Adding...';
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: 1, properties: sourceProps })
      });

      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.description || 'Could not add sample to cart');
      }

      // Redirect to same page with ?open_cart=1 to trigger cart drawer
      window.location = window.location.pathname + '?open_cart=1';
      return true;

    } catch (err) {
      console.error('[ARTO Gallery] Add sample failed:', err);
      if (button) {
        button.classList.remove('loading');
        button.textContent = button.dataset.originalText || 'Add Sample';
      }
      showToast('⚠ ' + err.message, false);
      return false;
    }
  }

  /**
   * Wire up individual "Add Sample" buttons.
   */
  sampleButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      const name = btn.dataset.name || 'Sample';
      if (!variantId) {
        showToast('⚠ This product has no variant ID — please check the product setup.', false);
        return;
      }
      addSample(variantId, name, btn);
    });
  });

  /**
   * Wire up "Order all samples" buttons.
   * Uses /cart/add.js with multiple items in a single request,
   * then redirects to trigger the cart drawer open.
   */
  orderAllButtons.forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();

      const eligible = Array.from(document.querySelectorAll('.ag-add-sample'))
        .map(b => ({
          id: parseInt(b.dataset.variantId, 10),
          name: b.dataset.name,
          quantity: 1
        }))
        .filter(item => item.id);

      if (eligible.length === 0) {
        showToast('No eligible products to add', false);
        return;
      }

      btn.classList.add('loading');
      btn.textContent = 'Adding ' + eligible.length + ' samples...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: eligible.map(item => ({ id: item.id, quantity: item.quantity, properties: sourceProps }))
          })
        });

        if (!response.ok) {
          const errData = await response.json().catch(() => ({}));
          throw new Error(errData.description || 'Could not add all samples');
        }

        // Redirect to same page with ?open_cart=1 to trigger cart drawer
        window.location = window.location.pathname + '?open_cart=1';

      } catch (err) {
        console.error('[ARTO Gallery] Order all failed:', err);
        btn.classList.remove('loading');
        btn.textContent = 'Order all samples →';
        showToast('⚠ ' + err.message, false);
      }
    });
  });

})();
